const breakPoints = {
  xs: {
    min: 0,
    max: 575.99
  },
  sm: {
    min: 576,
    max: 767.99
  },
  md: {
    min: 768,
    max: 991.99
  },
  lg: {
    min: 992,
    max: 1199.99
  },
  xl: {
    min: 1200,
    max: Infinity
  }
}

let currentBreakpoint = null

const _detectBreakPoint = () => {
  const widthWindow = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)

  for (const key in breakPoints) {
    if (widthWindow < breakPoints[key].max && widthWindow >= breakPoints[key].min) {
      currentBreakpoint = key
      return key
    }
  }

  return currentBreakpoint
}

const bsBreakpoints = {
  init () {
    _detectBreakPoint()
    window.addEventListener('resize', _detectBreakPoint)
  },

  getCurrentBreakpoint () {
    return currentBreakpoint
  },

  isTablet () {
    return currentBreakpoint === 'md'
  },

  isMobile () {
    return currentBreakpoint === 'xs' || currentBreakpoint === 'sm'
  },

  isTabletOrMobile () {
    return currentBreakpoint === 'md' || currentBreakpoint === 'xs' || currentBreakpoint === 'sm'
  },
}

bsBreakpoints.init()

export default bsBreakpoints
